import { useGetAuthMe } from "@birdwatch/client";
import { DEFAULT_TIME_ZONE } from "@/libs/date-fns";
import { UserProfileKey } from "@/types/openapi-enum";

export default function useTimezone() {
  const { data: me, isLoading } = useGetAuthMe().get({
    refetchOnWindowFocus: false,
  });

  const userTimezone =
    (me?.profiles?.find(({ key }: any) => key === UserProfileKey.TimeZone)
      ?.value as string) || DEFAULT_TIME_ZONE;
  return {
    timeZone: userTimezone,
    isLoading,
  };
}
